import React, { useEffect, useState } from 'react';
import { Select, Spin, Typography } from 'antd';
import {
  CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import { getOpsPrevisao } from '../../services/opsService';

const { Title } = Typography;

const formatCurrency = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export default function OpsPrevisaoPage() {
  const [loading, setLoading] = useState(true);
  const [meses, setMeses] = useState(6);
  const [previsao, setPrevisao] = useState([]);

  useEffect(() => {
    setLoading(true);
    getOpsPrevisao(meses).then((data) => {
      setPrevisao(data.previsao || []);
      setLoading(false);
    });
  }, [meses]);

  if (loading) return <Spin size="large" />;

  return (
    <div>
      <Title level={3}>Previsão de recebimento</Title>
      <p style={{ color: '#666', marginBottom: 16 }}>
        Projeção por assinatura ativa, usando a forma de pagamento real no Asaas e taxas configuradas (percentual + fixo).
      </p>
      <Select
        value={meses}
        onChange={setMeses}
        style={{ width: 120, marginBottom: 16 }}
        options={[
          { value: 3, label: '3 meses' },
          { value: 6, label: '6 meses' },
          { value: 9, label: '9 meses' },
          { value: 12, label: '12 meses' },
        ]}
      />
      <div className="ops-panel">
        <ResponsiveContainer width="100%" height={320}>
          <LineChart data={previsao}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" />
            <YAxis tickFormatter={(v) => `R$${v}`} />
            <Tooltip formatter={(v) => formatCurrency(v)} />
            <Legend />
            <Line type="monotone" dataKey="bruto_previsto" name="Bruto previsto" stroke="#1f4f4f" strokeWidth={2} />
            <Line type="monotone" dataKey="liquido_previsto" name="Líquido previsto" stroke="#b89040" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="ops-panel">
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th align="left">Mês</th>
              <th align="left">Bruto previsto</th>
              <th align="left">Líquido previsto</th>
              <th align="left">Assinantes</th>
            </tr>
          </thead>
          <tbody>
            {previsao.map((row) => (
              <tr key={row.mes}>
                <td>{row.label}</td>
                <td>{formatCurrency(row.bruto_previsto)}</td>
                <td>{formatCurrency(row.liquido_previsto)}</td>
                <td>{row.assinantes_ativos}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
